import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {GetShipmentsOptions, ShipmentsService} from "../services/shipments.service";
import {combineLatest, mergeMap} from "rxjs";
import {BranchesService} from "../services/branches.service";
import {UsersService} from "@hassel-it/angular-common";
import {ActivatedRoute} from "@angular/router";
import {map} from "rxjs/operators";

@Component({
    selector: 'app-picking-list',
    templateUrl: './picking-list.component.html',
    styleUrls: ['./picking-list.component.scss'],
    providers: [BranchesService]
})
export class PickingListComponent implements OnInit, AfterViewInit {
    private branches: any[];
    private branch: any;
    private userBranch: any;
    protected loading: boolean = true;
    private user: any;
    private userKey: any;
    @ViewChild('yourInput', {static: false}) yourInput: ElementRef;

    imageBase64 = 'iVBORw0KGgoAAAANSUhEUgAAAPYAAAAeAQMAAAAly3FkAAAABlBMVEX///8AAABVwtN+AAAAAXRSTlMAQObYZgAAAAlwSFlzAAAOxAAADsQBlSsOGwAAADRJREFUKJFj+Mx/+Pxhnj//bf7bfD58+Dw/v42N8Z8/hz8ftj/Mz/zZhmFUflR+VH7QygMAQJAQK2AXN7UAAAAASUVORK5CYII='


    public search: GetShipmentsOptions = {
        hideDropshipmentProductLines: true,
        showProductImages: false,
        sort: 'Shipments.created',
        direction: 'ASC',
    };
    protected shipmentPickingList: { shipments: any[], branch: string, initials:string, user_id: number};
    public log: any = [];
    initials:string;

    protected totalLines: any;
    protected totalQt: number;
    private stopBlur: boolean;

    constructor(private shipmentsService: ShipmentsService, private branchesService: BranchesService, private usersService: UsersService, public activatedRoute: ActivatedRoute) {
    }

    ngAfterViewInit() {
        this.focusInput();
    }

    private focusInput() {
        setTimeout(() => {
            this.yourInput.nativeElement.focus({preventScroll: true})
        }, 5);
    }

    setStopBlur($event) {
        this.stopBlur = true;
        $event.target.focus();
        // console.log($event);
    }

    setStartBlur($event) {
        this.stopBlur = false;
        this.focusInput();
    }

    onBlur($event: FocusEvent) {
        if (this.stopBlur) {
            return;
        }
        this.focusInput();
    }

    resetState() {
        this.search.nota_number = null;
        this.shipmentPickingList = {shipments: [], branch: this.branch, initials: null, user_id: this.user.id};
        this.countLines();
    }

    ngOnInit() {

        this.branches = this.branchesService.branchesDetails;
        combineLatest([
            this.activatedRoute.queryParams,
            this.usersService.getCurrentUser(),
        ]).subscribe(([params, user]) => {
            this.user = user;
            this.userKey = user.username.split('@')[0];
            const branchField = user.custom_fields.find((item) => {
                return item.key === 'branch'
            });

            if (branchField && branchField.value) {
                this.branch = branchField.value;
                this.userBranch = branchField.value;

                this.search.branch = [this.userBranch];
            }

            this.resetState();

            this.loading = false;
        })
    }

    addShipment() {

        this.log = [];
        this.loading = true;
        if (this.search.nota_number === '2199900000000') {
            this.createShipmentPickingList();
        } else {
            this.shipmentsService.getShipments(1, this.search).then((result) => {
                if (result.count >= 1) {
                    if (!this.shipmentPickingList.shipments.find(shipment => shipment.id === result.results[0].id)) {
                        this.shipmentPickingList.shipments.push(result.results[0]);
                        this.countLines();
                    } else {
                        this.log.push({message: 'Shipment already exists in picking list', shipment: result.results[0]})
                    }
                    console.log(result);
                }

                this.loading = false;
                this.search.nota_number = null;
            })
        }
    }

    createShipmentPickingList() {

        if (!this.initials) {
            this.log.push({message: 'Initialer er påkrævet'})
            this.search.nota_number = null;
            this.loading = false;
            return;
        }
        this.loading = true;
        this.shipmentPickingList.initials = this.initials;
        this.shipmentPickingList.user_id = this.user.id;
        this.shipmentsService.createShipmentPickingList(this.shipmentPickingList)
            .pipe(mergeMap((response) => {
                return this.shipmentsService.printPickingList(response.id)
            }))
            .subscribe((response) => {
                this.loading = false;
                this.resetState();
            });
    }

    protected removeShipment(shipment: any) {
        this.shipmentPickingList.shipments = this.shipmentPickingList.shipments.filter(item => item.id !== shipment.id);
    }

    private countLines() {
        if (this.shipmentPickingList.shipments.length === 0) {
            this.totalLines = 0;
            this.totalQt = 0
        } else {
            this.totalLines = this.shipmentPickingList.shipments.reduce((sum, shipment) => {
                return sum + (shipment.shipment_product_lines ? shipment.shipment_product_lines.length : 0);
            }, 0);
            this.totalQt = this.shipmentPickingList.shipments.reduce((sum, shipment) => {
                // tslint:disable-next-line:max-line-length
                return sum + (shipment.shipment_product_lines ? shipment.shipment_product_lines.reduce((sum, line) => sum + line.amount, 0) : 0);
            }, 0);
        }
    }
}
